import { useGetSiteSettings } from "#/_packages/umbrella/hooks/useGetSiteSettings";
import { m } from "#/paraglide/messages";

type TagPage = {
	contentType: string;
	properties?: { tags?: string[] | null; hideTags?: boolean | null } | null;
};

export function shouldShowPageTags(page: TagPage, enabled?: boolean) {
	return (
		enabled === true &&
		!page.properties?.hideTags &&
		[
			"standardUmbPage",
			"newsUmbPage",
			"eventUmbPage",
			"blogPostUmbPage",
		].includes(page.contentType) &&
		(page.properties?.tags?.some((tag) => tag.trim().length > 0) ?? false)
	);
}

export function tagSearchHref(url: string, tag: string) {
	const hashIndex = url.indexOf("#");
	const hash = hashIndex >= 0 ? url.slice(hashIndex) : "";
	const destination = hashIndex >= 0 ? url.slice(0, hashIndex) : url;
	return `${destination}${destination.includes("?") ? "&" : "?"}tags=${encodeURIComponent(tag)}${hash}`;
}

export function useShowPageTags(page: TagPage) {
	const settings = useGetSiteSettings();
	// Additive field remains compatible with clients generated before the update.
	return shouldShowPageTags(
		page,
		(settings as { showPageTags?: boolean } | undefined)?.showPageTags,
	);
}

export function PageTags({ content }: { content: TagPage }) {
	const settings = useGetSiteSettings();
	const visible = shouldShowPageTags(
		content,
		(settings as { showPageTags?: boolean } | undefined)?.showPageTags,
	);
	if (!visible) return null;
	const tags = [
		...new Set(content.properties?.tags?.filter((tag) => tag.trim()) ?? []),
	];
	const searchUrl = settings?.searchPage?.route.path;
	return (
		<div className="container page-tags my-6">
			<nav
				className="read-width flex flex-wrap items-center gap-2"
				aria-label={m.search_tags()}
			>
				<span className="font-bold">{m.search_tags()}</span>
				{tags.map((tag) =>
					searchUrl && searchUrl !== "#" ? (
						<a
							key={tag}
							className="tag inactive"
							href={tagSearchHref(searchUrl, tag)}
						>
							{tag}
						</a>
					) : (
						<span key={tag} className="tag">
							{tag}
						</span>
					),
				)}
			</nav>
		</div>
	);
}
